import React, { useState, useEffect } from 'react';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Shraddha.scss';
import VratLinks from '../../../components/VratLinks/VratLinks';
import axios from 'axios';
import city from '../../../city.json'




const formatTime = (fullStr, format = '12hr') => {
  if (typeof fullStr !== 'string') return '--';

  // Match time with optional AM/PM
  const match = fullStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)?/i);

  if (!match) return fullStr; // If no match, return original string

  let [_, hh, mm, period] = match;
  let hours = parseInt(hh, 10);
  const minutes = parseInt(mm, 10);

  let replacementTime = '';

  if (format === '24hr' || format === '24hr+') {
    // Convert to 24-hour format
    if (period?.toUpperCase() === 'PM' && hours !== 12) hours += 12;
    if (period?.toUpperCase() === 'AM' && hours === 12) hours = 0;

    const paddedHours = hours.toString().padStart(2, '0');
    const paddedMinutes = minutes.toString().padStart(2, '0');

    replacementTime = `${paddedHours}:${paddedMinutes}`;
    if (format === '24hr+') {
      replacementTime += ':00'; // add seconds
    }
  } else {
    // 12-hour format
    let suffix = period;
    if (!suffix) {
      suffix = hours >= 12 ? 'PM' : 'AM';
    }

    if (hours === 0) {
      hours = 12;
    } else if (hours > 12) {
      hours = hours - 12;
    }

    replacementTime = `${hours}:${mm} ${suffix.toUpperCase()}`;
  }

  // Replace only the matched time part in the original string
  return fullStr.replace(match[0], replacementTime);
};






const shraddhaImageMap = {
  'Purnima Shraddha': 'https://www.drikpanchang.com/images/purnima/ashwin/maha-raas/sharad_purnima_maha_raas.jpg',
  'Pratipada Shraddha': 'https://files.prokerala.com/images/pratipada-shraddha-1.jpg',
  'Dwitiya Shraddha': 'https://vedicprayers.com/wp-content/uploads/2024/09/Dwitiya-Shradh-1024x585.jpeg',
  'Tritiya Shraddha': 'https://www.drikpanchang.com/images/events/akshaya-tritiya/3x/akshaya_tritiya_vishnu_lakshmi_puja.jpg',
  'Maha Bharani': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKadJFQEpIk2RkHCT0aVQd05WEJRkJYEaf9g&s',
  'Panchami Shraddha': 'https://www.drikpanchang.com/images/events/vasant-panchami/xhindu_family_saraswati_puja.jpg.pagespeed.ic.pGLk34ZO5x.jpg',
  'Shashthi Shraddha': 'https://www.templepurohit.com/wp-content/uploads/2017/06/Skanda-Sashti-Kavacham-800x410.jpg',
  'Saptami Shraddha': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS66T3ZKgXB1DmJWsCJqC7x8OCmlvF8mA4amw&s',
  'Ashtami Shraddha': 'https://dkscore.b-cdn.net/avatar/ashtami-shraddha-dkscore_1731584492878.png',
  'Navami Shraddha': 'https://www.vedadhara.com/audios/ramnavamihindi.webp',
  'Dashami Shraddha': 'https://dkscore.b-cdn.net/avatar/dashami-shraddha-dkscore_1731585754160.png',
  'Ekadashi Shraddha': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTQnkEL1hEdq1M-BBUroqAM4DmVP2CzZrOmDw&s',
  'Magha Shraddha': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT54isWmq__ulxpUlBdEwCXIOpb6628I50ZMGP9TY_HiFapGSwISXe5JsHhNxLm5Ak4sbY&usqp=CAU',
  'Trayodashi Shraddha': 'https://static.toiimg.com/thumb/imgsize-23456,msid-112673822,width-600,resizemode-4/112673822.jpg',
  'Chaturdashi Shraddha': 'https://akm-img-a-in.tosshub.com/indiatoday/images/story/202209/chhath-puja-6109132_1920_1_x.jpeg?VersionId=6ogb9y9EXUraywsRua19hRU7SptNrOGk',
  'Sarva Pitru Amavasya': 'https://www.futurepointindia.com/styles/newimg/pujas/sarvapitru-amavasya-shradh.jpg',
};








const Shradha = () => {
  const [year, setYear] = useState(2025);
  const [location, setLocation] = useState('kolkata');
  const [timeFormat, setTimeFormat] = useState('12');

  const [shraddhaList, setShraddhaList] = useState([]);
   const [tempLocation, setTempLocation] = useState("Kolkata");
  const [suggestions, setSuggestions] = useState([]);
  const [selectedShraddha, setSelectedShraddha] = useState(null);


  const changeYear = (offset) => setYear((prev) => prev + offset);
  const handleYearInput = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val)) setYear(val);
  };

  const shraddhaTooltips = {
  "Purnima Shraddha": "Performed on the full moon day for those who passed away on a Purnima. It marks the beginning of Shraddha rituals.",
  "Pratipada Shraddha": "This Shraddha is observed for those who died on the Pratipada tithi (first day of Krishna Paksha).",
  "Dwitiya Shraddha": "Conducted for ancestors who died on Dwitiya tithi, the second day of the waning moon phase.",
  "Tritiya Shraddha": "Tritiya Shraddha is performed for those who passed away on the third lunar day.",
  "Maha Bharani": "A special Shraddha performed on Bharani Nakshatra, considered highly auspicious for appeasing ancestors.",
  "Panchami Shraddha": "Offered for those who died on Panchami tithi, the fifth day of the lunar cycle.",
  "Shashthi Shraddha": "This is done for those who passed on the sixth lunar day (Shashthi).",
  "Saptami Shraddha": "Shraddha rituals on the seventh lunar day for departed souls who died on Saptami.",
  "Ashtami Shraddha": "For those who died on the eighth tithi. Ashtami Shraddha has its own significance in Pitru Paksha.",
  "Navami Shraddha": "This day is also known as Matri Navami, mainly dedicated to mothers and maternal ancestors.",
  "Dashami Shraddha": "Shraddha for those who departed on Dashami tithi (10th lunar day).",
  "Ekadashi Shraddha": "Performed on the eleventh lunar day for ancestors who passed away on Ekadashi.",
  "Magha Shraddha": "Observed when Magha Nakshatra coincides with Shraddha tithi. Considered sacred and beneficial.",
  "Trayodashi Shraddha": "Rituals for ancestors who left on Trayodashi (13th lunar day) are done on this day.",
  "Chaturdashi Shraddha": "Dedicated to those who died in violent ways or accidents, done on the 14th lunar day.",
  "Sarva Pitru Amavasya": "The most important day of Pitru Paksha, for all departed souls regardless of tithi."
};


useEffect(() => {
  const fetchshraddhaData = async () => {
    try {
     if (!location || location.trim() === '') return;
      const response = await axios.get(
        `https://core-c343.onrender.com/api/shraddha?year=${year}&location=${encodeURIComponent(location)}`
      );
      
     
      if (response.data && response.data.shraddhaDates) {
        setShraddhaList(response.data.shraddhaDates);
      } else {
        setShraddhaList([]);
      }
   
 
    } catch (error) {
      console.error("Failed to fetch shraddha data:", error);
      setShraddhaList([]);
    }
  };

  fetchshraddhaData();
}, [year, location]);

  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const [currentDate, setCurrentDate] = useState(new Date());


  const readableDate = `${months[currentDate.getMonth()]} ${currentDate.getDate()}, ${currentDate.getFullYear()}`;
  const weekDay = currentDate.toLocaleDateString("en-US", { weekday: "long" });
  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);

    // filter cities when user types
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4)); // show only first 4 results
    } else {
      setSuggestions([]);
    }
  };

const handleSelect = (cityName) => {
  setTempLocation(cityName);
  setLocation(cityName); // 🔥 REQUIRED
  setSuggestions([]);
};



  return (
    <div className="shraddha-container">
      <InnerNav />
      <div className="Shraddha-content">
        <Zodiac />

        <div className="calendar-wrapper">
          <div className="calendar-header dark">
            <div className="highlight">
              <h2>{year} Shraddha Dates</h2>
              <div className="current-ekadashi">
                <img
                  src="https://st3.depositphotos.com/1888161/16293/i/1600/depositphotos_162937726-stock-photo-hindu-ceremony-puja.jpg"
                  alt="Shraddha"
                  className="moon-preview"
                />
                <div>
                  
                  <p>{location}</p>
                </div>
                <div className="current-date">
                  <p><strong>{currentDate.getDate()}</strong></p>
                  <p>{readableDate}</p>
                  <p>{weekDay}</p>
                </div>
              </div>


              <div className="Shraddha-controls">
               <div className="location-date">
                   <div className="input-with-icon">
                  <span className="icon">📍</span>
                  <input
                    type="text"
                    value={tempLocation}
                    onChange={handleChange}
                    placeholder="Enter location"
                  />
                  {suggestions.length > 0 && (
                    <ul className="dropdown">
                      {suggestions.map((c, idx) => (
                        <li key={idx} onClick={() => handleSelect(c.city)}>
                          {c.city}, {c.state}, {c.country}
                        </li>
                      ))}
                    </ul>
                  )}
                  </div>
                  
                </div>
                <input type="number" value={year} onChange={handleYearInput} />
                <button onClick={() => changeYear(-1)}>Prev Year</button>
                <button onClick={() => setYear(new Date().getFullYear())}>Current Year</button>
                <button onClick={() => changeYear(1)}>Next Year</button>
                <div className="clock-modes">
                <button className={timeFormat === '12hr' ? 'active' : ''} onClick={() => setTimeFormat('12hr')}>
                    12 Hour
                  </button>
                  <button className={timeFormat === '24hr' ? 'active' : ''} onClick={() => setTimeFormat('24hr')}>
                    24 Hour
                  </button>
                  <button className={timeFormat === '24hr+' ? 'active' : ''} onClick={() => setTimeFormat('24hr+')}>
                    24 Plus
                  </button>
                  </div>
              </div>
            </div>
          </div>

{!selectedShraddha ? (
  <div className="shraddhaa-list">
    {shraddhaList.length === 0 && (
      <p>No shraddha data available for selected year/location.</p>
    )}

    {shraddhaList.map((item, idx) => (
      <div
        className="shraddhaa-item clickable"
        key={idx}
        onClick={() => setSelectedShraddha(item)}
      >
        <img
          src={
            shraddhaImageMap[item.title] ||
            "https://st3.depositphotos.com/1888161/16293/i/1600/depositphotos_162937726-stock-photo-hindu-ceremony-puja.jpg"
          }
          alt={item.title}
        />

        <div className="shraddhaa-details">
          <p className="shraddhaa-date">{item.date}</p>

          {/* <div className="tooltip-wrapper">
            <div className="shraddhaa-name">{item.title}</div>
            <span className="tooltip-text">
              {shraddhaTooltips[item.title] || "No info available"}
            </span>
          </div> */}
          <div className="shraddhaa-name">{item.title}</div>

          <p className="shraddhaa-phase">{item.nakshatra}</p>
          <p className="shraddhaa-tithi">{item.tithiName}</p>
          <p className="shraddhaa-tithi">{item.duration}</p>
        </div>

        <div className="shraddhaa-timings">
          <p>{item.lunarDetail}</p>
          <p>{formatTime(item.tithiStart, timeFormat)}</p>
          <p>{formatTime(item.tithiEnd, timeFormat)}</p>
        </div>
      </div>
    ))}
  </div>
) : (
  <div className="san-detail-view">
    <button
      className="back-btn"
      onClick={() => setSelectedShraddha(null)}
    >
      ← Back
    </button>

    <h2>{selectedShraddha.title}</h2>

    <img
      src={
        shraddhaImageMap[selectedShraddha.title] ||
        "https://st3.depositphotos.com/1888161/16293/i/1600/depositphotos_162937726-stock-photo-hindu-ceremony-puja.jpg"
      }
      alt={selectedShraddha.title}
    />

    <p><strong>Date:</strong> {selectedShraddha.date}</p>
    {/* <p><strong>Nakshatra:</strong> {selectedShraddha.nakshatra}</p>
    <p><strong>Tithi:</strong> {selectedShraddha.tithiName}</p> */}
    <p><strong>Duration:</strong> {selectedShraddha.duration}</p>

    <p><strong>Lunar Detail:</strong> {selectedShraddha.lunarDetail}</p>

    <p><strong>Tithi Start:</strong> {formatTime(selectedShraddha.tithiStart, timeFormat)}</p>
    <p><strong>Tithi End:</strong> {formatTime(selectedShraddha.tithiEnd, timeFormat)}</p>

    {shraddhaTooltips[selectedShraddha.title] && (
      <p><strong>Significance:</strong> {shraddhaTooltips[selectedShraddha.title]}</p>
    )}
  </div>
)}

        </div>

        <section className="shraddha-wrapper">
      <h1 className="shraddha-title">Shraddha Days</h1>
      <div className="shraddha-texts">
        <p>
          Pitru Paksha is a 15 lunar days period when Hindus pay homage to their ancestors, especially through food offerings.
        </p>
        <p>
          According to South Indian Amanta calendar it falls in the lunar month of Bhadrapada beginning with the full moon day or day after full moon day.
        </p>
        <p>
          According to North Indian Purnimanta calendar this period falls in the lunar month of Ashwin beginning with the full moon day in Bhadrapada or next day of full moon day.
        </p>
        <p>
          It is just nomenclature of lunar months which differs and both North Indians and South Indians perform Shraddha ritual on similar days.
        </p>
        <p>
          The last day of Pitru Paksha is known as Sarvapitri Amavasya or Mahalaya Amavasya. Mahalaya Amavasya is the most significant day of Pitru Paksha.
        </p>
      </div>
    </section>
        <VratLinks/>
      </div>
      <Footer />
    </div>
  );
};

export default Shradha;
